/*------------------------
loader
--------------------------*/
$('.loader-wrapper').fadeOut('slow', function() {
    $(this).remove();
});